<p500-ui-many-items
  [data]="mappedData"
  [tableHeaders]="tableHeaders"
  [tmpl]="tmpl"
  [buttonTmpl]="buttonTmpl"
  [previewTmpl]="previewTmpl"
  [maxWidth]="'calc(620px + 20vw)'"
  [popupClass]="'c-popup__table'"
></p500-ui-many-items>

<ng-template #previewTmpl></ng-template>
<ng-template let-data="data" #tmpl>
  <gtd-ui-field-dynamic [type]="data.type" [data]="data.value" [ngClass]="data.customClass"></gtd-ui-field-dynamic>
</ng-template>
<ng-template let-open="open" #buttonTmpl>
  <div class="c-field-value c-field-value--view-mode d-flex">
    <span class="c-field-value__icon" (click)="open($event)">
      <p500-ui-icon name="menu-eye"></p500-ui-icon>
    </span>
    <span><ng-container i18n="@@common.show">Show</ng-container> ({{ mappedData.length - 1 }})</span>
  </div>
</ng-template>
